module.exports = __webpack_public_path__ + "img/active3.7e76066c.png";